var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"landing-header"},[_c('p',{staticClass:"landing-header__subheading"},[_vm._v(_vm._s(_vm.subheading))]),_c('h1',{staticClass:"landing-header__heading"},[_vm._v(" "+_vm._s(_vm.heading)+" "),_c('span',{staticClass:"landing-header__heading-red"},[_vm._v(_vm._s(_vm.headingRed))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }